module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/01.Developer/0.Web/Bravo8-Base/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main